import { render, staticRenderFns } from "./RetunsListItem.vue?vue&type=template&id=66ebd19e&"
import script from "./RetunsListItem.vue?vue&type=script&lang=js&"
export * from "./RetunsListItem.vue?vue&type=script&lang=js&"
import style0 from "./RetunsListItem.vue?vue&type=style&index=0&id=66ebd19e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports